import styles from "./Login.module.css"
import LoginPanel from "../components/LoginPanel"
import Logo from "../images/BOOKR-Class-logo-color.svg"
import Abstract from "../images/abstract-3.svg"
import { Navigate, useNavigate } from 'react-router-dom';
import { isVietnamHost } from "../utils/host.js";
import { Translate } from "../features/database/uiTexts.js";
import { getGoEduSsoUrl } from "../utils/sso.js";
import { useEffect } from "react";

export default function Login()  {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate('/', {replace: false});
      };

    const hasLoggedInUser = () => localStorage.getItem('hasUser') === 'true';
    const hasLoggedInUserValue = hasLoggedInUser();
    const isVietnamHostValue = isVietnamHost();
    const loginSSOGoEduButtonURL = Translate("vtc_goedu_web_sso_login_url");
    const loginSSOGoEduButtonURLStaging = Translate("vtc_goedu_web_sso_login_url");

    useEffect(() => {
        if (!isVietnamHostValue || hasLoggedInUserValue) return;

        const isStaging = window.location.href.includes("app-staging.");
        const goEduLink = getGoEduSsoUrl({
            isStaging,
            prodUrl: loginSSOGoEduButtonURL?.value,
            stagingUrl: loginSSOGoEduButtonURLStaging?.value
        });

        window.location.replace(goEduLink);
    }, [isVietnamHostValue, hasLoggedInUserValue, loginSSOGoEduButtonURL, loginSSOGoEduButtonURLStaging]);

    return (<div>
                { hasLoggedInUserValue ? <Navigate to="/" /> :
                <div className={styles.Main}>
                    <div className={styles.Logo} onClick={handleClick}>
                        <img src={Logo} alt="Bookr Class Logo"/>
                    </div>
                    <LoginPanel/>
                    <div className={styles.Abstract}>
                        <img src={Abstract} alt="Bookr Class Logo"/>
                    </div>
                </div>
                }
            </div>)
}
